// ================================================= /
// ======   Home Phone JS   ======================== /
// ================================================= /

/* global jQuery */

import { gsap } from 'gsap';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin';

import animation from '../animation';

gsap.registerPlugin( DrawSVGPlugin, MotionPathPlugin );

/**
 * Class for the home phone.
 * Animates the bloody thing.
 */
class DispatchSkinHomePhone {

	/**
	 * Constructs the class and sets up instance variables.
	 */
	constructor() {

		this.selector = '.js-animastration--type-home-phone';

		// Elements

		this.element = jQuery( this.selector );
		this.uiCards = this.element.find( '.js-animastration__ui-card' );
		this.progress = this.element.find( '.js-animastration__progress' );
		this.buildings = this.element.find( '.js-animastration__building' );

		this.svgs = this.element.find( '.js-animastration__svg' );
		this.paths = this.svgs.find( 'path' );

		this.icons = this.element.find( '.js-animastration__icon' );

		this.timeline = null;
	}

	/**
	 * Initializes the class, sets up events.
	 */
	initialize() {

		if ( jQuery( this.selector ).length ) {

			this.timeline = gsap.timeline( { paused: true, callbackScope: this } );

			this.timeline.to( this.uiCards.eq( 0 ), { duration: 0.5, ease: 'back.inOut',	x: '10%', y: '-20%'	} )
				.to( this.uiCards.eq( 1 ), { duration: 0.5, ease: 'back.inOut',	x: '-10%', y: '18%' }, '>-0.35' )
				.to( this.uiCards.eq( 2 ), { duration: 0.5, ease: 'back.inOut',	x: '-10%', y: '-20%' }, '>-0.35' )

				.addLabel( 'progressLeft' )
				.call( () => animation.resolve( this.buildings.eq( 0 ) ), [], '>-0.5' )
				.to( this.paths.eq( 1 ), { duration: 3, ease: 'none', drawSVG: '0 100% live' }, '>-0.125' )
				.to( this.progress, { duration: 0.35, ease: 'back.out(10)', scale: 1 }, '<' )
				.to(
					this.progress,
					{
						duration: 3,
						ease: 'none',
						motionPath: {
							path: '.js-animastration__progress-path-left',
							align: '.js-animastration__progress-path-left',
							offsetY: -1
						}
					},
					'<'
				)

				.to( this.icons.eq( 0 ), { duration: 0.5, ease: 'back.out(4)', scale: 1 }, 'progressLeft+=1' )
				.to( this.icons.eq( 1 ), { duration: 0.5, ease: 'back.out(4)', scale: 1 }, 'progressLeft+=2' )
				.set( this.progress, { scale: 0, zIndex: 1 } )
				.to( this.uiCards.eq( 1 ), { duration: 0.5, ease: 'back.inOut(2)', x: '+=10%', y: '-=18%' }, '>-0.25' )
				.to( this.uiCards.eq( 0 ), { duration: 0.5, ease: 'back.inOut(2)', x: '-=10%', y: '+=20%' }, '<0.125' )
				.to( this.uiCards.eq( 2 ), { duration: 0.5, ease: 'back.inOut(2)', x: '+=10%', y: '+=20%' }, '<' )
				.to( this.buildings.eq( 0 ), { duration: 0.5, ease: 'back.inOut(2)', scale: 0.95 }, '>-0.325' )

				.addLabel( 'progressBottom' )
				.to( this.paths.eq( 3 ), { duration: 1.75, ease: 'none', drawSVG: '0 100% live' }, '>-0.55' )
				.to( this.progress, { duration: 0.3, ease: 'back.out(10)', scale: 1 }, '<' )
				.to(
					this.progress,
					{
						duration: 1.75,
						ease: 'none',
						motionPath: {
							path: '.js-animastration__progress-path-bottom',
							align: '.js-animastration__progress-path-bottom',
							offsetY: -1,
							offsetX: -1
						}
					},
					'<'
				)

				.call( () => animation.resolve( this.buildings.eq( 1 ) ), [], '>-0.35' )
				.to( this.icons.eq( 2 ), { duration: 0.5, ease: 'back.out(4)', scale: 1 }, 'progressBottom+=1.75' )
				.to( this.icons.eq( 3 ), { duration: 0.5, ease: 'back.out(4)', scale: 1 }, 'progressBottom+=1' )
				.to( this.progress, { duration: 2.5, ease: 'back.out(10)', scale: 5, opacity: 0 }, '>-0.2' );

			// Animation hooks

			animation.addHook(
				this.selector,
				() => this.timeline.play()
			);
			animation.addHook(
				this.selector,
				() => this.timeline.pause( 0 ),
				false
			);
		}
	}

}

const homePhone = new DispatchSkinHomePhone();
export default homePhone;



// WEBPACK FOOTER //
// ./src/js/inc/animations/home-phone.js